function TaskScheduler ({stopped, initialTime, elapsedTime, intervalTime, intervalTimeAux, reseted, rounds, targetFunc, updateEvery, runOnStart}) {
  this.stopped = stopped || true
  this.initialTime = initialTime || null
  this.elapsedTime = elapsedTime || 0
  this.intervalTime = intervalTime || 60000
  this.intervalTimeAux = intervalTimeAux || intervalTime
  this.reseted = reseted || true
  this.rounds = rounds || []
  this.targetFunc = targetFunc || function () {}
  this.updateEvery = updateEvery || 500
  this.runOnStart = runOnStart || false

  this.main = function () {
    if (this.stopped) {
      this.initialTime = null
      this.intervalTimeAux = this.intervalTimeAux - this.elapsedTime
      this.rounds.push(this.elapsedTime)
      return
    }
    if (this.initialTime === null) {
      this.initialTime = Date.now()
    }
    this.elapsedTime = Date.now() - this.initialTime
    if (this.elapsedTime >= this.intervalTimeAux) {
      this.targetFunc()
      this.intervalTimeAux = intervalTime
      this.elapsedTime = 0
      this.initialTime = Date.now()
    }
    this.nloop()
  }

  this.nloop = function () {
    let self = this
    setTimeout(function () {
      self.main()
    }, this.updateEvery)
  }

  this.reset = function () {
    this.reseted = true
    this.stopped = true
    this.intervalTimeAux = intervalTime
    this.initialTime = null
    this.elapsedTime = 0
    this.rounds = []
  }

  this.stop = function () {
    this.stopped = true
  }

  this.start = function () {
    if (this.stopped) {
      if (this.reseted) {
        if (this.runOnStart) {
          console('onStart', this)
          this.targetFunc()
        }
        this.reseted = false
      }
      this.stopped = false
      this.main()
    }
  }
}

export {TaskScheduler}



// WEBPACK FOOTER //
// ./src/utils/taskScheduler.js